import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import Form from 'components/react-validation/components/form';
import Textarea from 'components/react-validation/components/text-area';
import Submit from 'components/react-validation/components/submit';

import Dropzone from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';

import * as Vali from 'helper/validator-helper';
import * as CommonActionType from 'Common/constants';
import * as ProjectActionType from 'Projects/constants';

import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Autocomplete from 'react-autocomplete';

import emptyImages from 'assets/img/empty-images.svg';
import plusIcon from 'assets/img/add-plus-icon.svg';

class InventoryAdd extends React.Component {
    static propTypes = {
      dispatch: PropTypes.func,

      projectId: PropTypes.string,
      suggestCategoryInfo: PropTypes.object,
      templateCategoryProfile: PropTypes.object,
      createNewCategoryErrorMsg: PropTypes.string,
      goBack: PropTypes.func
    }
    constructor(props) {
      super(props);
      this.state = {
        name: '',
        note: '',
        imageFiles: [],
        cancelUploadList: {},
        deleteUploadList: {},
        listImages: [],
        imagePreview: null,
        suggestData: [],
        errorExistedName: null
      };
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.suggestCategoryInfo !== this.props.suggestCategoryInfo) {
        this.setState({
          suggestData: nextProps.suggestCategoryInfo
        });
      }
      if (nextProps.templateCategoryProfile !== this.props.templateCategoryProfile) {
        this.setState({
          listImages: nextProps.templateCategoryProfile.images
        });
      }

      if (this.props.createNewCategoryErrorMsg !== nextProps.createNewCategoryErrorMsg) {
        this.setState({
          errorExistedName: nextProps.createNewCategoryErrorMsg
        });
      }
    }

    componentWillUnmount() {
      this.setState({
        errorMsg: null
      });
    }

    onSubmit = (e) => {
      e.preventDefault();
      const {projectId} = this.props;
      const {listImages} = this.state;
      const formValues = this.form.getValues();

      this.props.dispatch({
        type: ProjectActionType.CREATE_NEW_CATEGORY_ASYNC,
        params: {
          data: {
            projectId: projectId,
            name: this.state.name.trim(),
            note: formValues.note.trim(),
            images: listImages
          }
        }, callback: () => {
          this.props.goBack();
        }
      });
    }

    onDrop = (accepted, rejected) => {
      if (rejected.length) {
        const errorMsg = 'Only PNG, JPG, JPEG, BMP, TIFF supported.';
        this.setState({
          error: errorMsg
        });
      } else if ((accepted.length + this.state.listImages.length) > 5) {
        const errorMsg = 'Maximum 5 files uploaded.';
        this.setState({
          error: errorMsg
        });
      } else {
        const currentFileState = [...this.state.imageFiles];

        this.setState(
          {
            files: currentFileState.concat(accepted),
            error: null
          },
          () => this.handleFileUpload(accepted)
        );
      }
    }

    onClearError = () => {
      this.setState({ error: null});
    };

    renderError = () => {
      const { error } = this.state;

      if (error) {
        setTimeout(this.onClearError, 5000);
        return (
          <div
            className='alert alert-danger'
            style={{ width: '100%', margin: '0 15px 15px' }}
          >
            <p style={{ fontSize: 14 }}>{error}</p>
            <i
              className='fa fa-close'
              style={{
                position: 'absolute',
                top: 14,
                right: 14,
                cursor: 'pointer'
              }}
              onClick={this.onClearError}
            />
          </div>
        );
      }

      return null;
    };

    renderErrorMsg = () => {
      const {errorExistedName} = this.state;
      if (errorExistedName) {
        return (
          <span className='cls-danger help-block'>
            {errorExistedName}
          </span>
        );
      }

      return null;
    }

    handleFileUpload = (files) => {
      const {projectId} = this.props;
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `projects/${projectId}/home-inventory/categories-image`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;

          files.map(file => {
            file.uploadId = uuidv4();
            //handle image file
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: (status, callbackData) => {
                callbackData.name = file.name;

                if (status === 'pending') {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                      callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList
                  });
                } else if (status === 'delete') {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                      callbackData.deleteFile;
                  this.setState({
                    deleteUploadList
                  });
                } else if (status === true) {
                  this.getImageUrl(callbackData, callbackData);
                }
              }
            });
          });
        }
      });
    }

    getImageUrl = (fileData) => {
      const {listImages} = this.state;
      let file = {};
      file.fileName = fileData.name;
      file.key = fileData.data.Key;
      file.url = fileData.data.Location;
      file.thumbnailKey = fileData.data.Key;
      file.thumbnailUrl = fileData.data.Location;
      listImages.push(file);
      this.setState({
        listImages: listImages
      });
    }

    onTogglePreviewImages = (url) => {
      this.setState({
        imagePreview: url
      });
    }

    onRemoveImage = (e, id) => {
      e.preventDefault();
      let {listImages} = this.state;
      listImages.splice(_.indexOf(listImages, _.find(listImages, { fileName: id})), 1);
      this.setState({
        listImages: listImages
      });
    }

    onSearchSuggestion = (event, text) => {
      const searchKey = text.toLowerCase().trim();
      if (searchKey.length < 2) {
        this.setState({name: text, suggestData: []});
        return;
      }

      this.setState({
        name: text
      }, () => {
        this.props.dispatch({
          type: ProjectActionType.SUGGEST_INFORMATION_CATEGORY_ASYNC,
          params: {
            categoryName: text.toLowerCase().trim()
          }
        });
      });
    }

    render() {
      let {name, note, listImages, imagePreview } = this.state;
      const acceptFileType = 'image/jpeg, image/png , image/bmp, image/jpg, image/tiff';

      const breadcrumbs = [
        {title: 'Inventory', url: '/', onCustomAction: this.props.goBack},
        {title: 'Add new inventory', url: ''}
      ];

      if (this.form) {
        note = this.form.getValues().note;
      }
      return (
        <React.Fragment>
          <div className='container-fluid'>
            <h4 style={{margin: '0px 0px 10px'}}>New inventory</h4>
            <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
              <div className='add-new-category-item-add row'>
                <div className='col-md-6 col-xs-6'>
                  <div className='form-group'>
                    <label >Name <strong className='text-danger'>*</strong></label>
                    <Autocomplete
                      className='inputText'
                      inputProps={{
                        id: 'states-autocomplete',
                        className: 'form-control',
                        max: '254',
                        maxLength: '254',
                        name: 'name'
                      }}
                      wrapperStyle={{ position: 'relative' }}
                      value={name}
                      items={this.state.suggestData}
                      getItemValue={(item) => item.name}
                      onSelect={(value, item) => {
                        this.setState({name: value, suggestData: [item]}, () => {
                          this.props.dispatch({
                            type: ProjectActionType.GET_SELECTED_TEMPLATE_CATEGORY_ASYNC, params: {templateId: this.state.suggestData[0].id}, callback: () => this.setState({suggestData: []})
                          });
                        });
                      }}
                      onChange={this.onSearchSuggestion}
                      renderMenu={children => (
                        <div className='suggestion-menu'>
                          {children}
                        </div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
                          key={item.name}
                        >
                          {item.name}
                          {!isEmpty(item.images) && <span style={{marginLeft: 15}}><img className='category-img-item' src={!isEmpty(item.images) && item.images[0].thumbnailUrl} /></span>}
                        </div>
                      )}
                      ref='name'
                    />
                    {this.renderErrorMsg()}
                  </div>
                  <div className='form-group'>
                    <label>Notes</label>
                    <Textarea
                      style={{minHeight: 300}}
                      name='note'
                      ref='note'
                      className='form-control'
                      value={note}
                      max='1000'
                      maxLength='1000'
                      validations={[Vali.maxlength]}
                    />
                  </div>
                </div>
                <div className='image-category col-md-6 col-xs-6'>
                  {this.renderError()}
                  <div className='preview-category-image'>
                    <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-md-12 col-xs-12'>
                          {imagePreview && <img
                            className='empty-category-image'
                            src={imagePreview && !isEmpty(listImages) ? imagePreview : emptyImages}
                            alt='no-files'
                          />}
                          {!imagePreview && <img
                            className='empty-category-image'
                            src={this.state.listImages && this.state.listImages[0] ? this.state.listImages[0].url : emptyImages}
                            alt='no-files'
                          />}
                        </div>
                      </div>
                    </div>
                    <div className='list-thumbnail-image-after-upload'>
                      <div className='row'>
                        {/* map img*/}

                        <div className='container-fluid'>
                          <div className='col-md-12 col-xs-12'>
                            {!isEmpty(listImages) && (
                              listImages.map((el, index) => {
                                return (
                                  <div key={index} className='image-file-after-upload col-md-2 col-xs-2 col-lg-2'>
                                    <span onClick={(e) => this.onRemoveImage(e, el.fileName)} className='close'>&times;</span>
                                    <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                                  </div>
                                );
                              })
                            )}
                            {
                              listImages.length < 5 &&
                             <div className='image-file-after-upload col-md-2 col-xs-2 col-lg-2'>
                               <Dropzone
                                 disableClick
                                 accept={acceptFileType}
                                 ref={node => {
                                   this.dropzoneRef = node;
                                 }}
                                 className='category-images-dropzone'
                                 onDrop={this.onDrop}
                               >
                                 <button
                                   onClick={(e) => {
                                     e.preventDefault();
                                     this.dropzoneRef.open();
                                   }}
                                   className='add-image-category btn btn-primary btn-siteone-default'
                                 >
                                   <img
                                     src={plusIcon} />
                                 </button>
                               </Dropzone>
                             </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='thumbnail-image-add-success' />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <span className='btn btn-siteone-default' onClick={this.props.goBack}>Cancel</span>
                  <Submit className='btn btn-primary btn-siteone' disabled={!this.state.name.trim()}>Create</Submit>
                </div>
              </div>
            </Form>
          </div>
        </React.Fragment>
      );
    }

}

const mapStateToProps = state => {
  return {
    createNewCategoryErrorMsg: state.ProjectStore.createNewCategoryErrorMsg,
    templateCategoryProfile: state.ProjectStore.templateCategoryProfile,
    suggestCategoryInfo: state.ProjectStore.SuggestCategoryInfo
  };
};

export default connect(mapStateToProps)(InventoryAdd);



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/inventory-add.js